// extracted by mini-css-extract-plugin
export default {"infoSection":"InfoSection_infoSection__Qumsl","title":"InfoSection_title__76Rd4","images":"InfoSection_images__8VN08","text":"InfoSection_text__A62cD"};